import React from "react";

/**
 * ReviewScreen
 * Displays all answers collected so far in the current session.
 * Scaffold for future inline re-recording / edit flow.
 */
export function ReviewScreen({ collectedAnswers, onBack, onEditAnswer }) {
  const hasAnswers = collectedAnswers && collectedAnswers.length > 0;

  return (
    <div className="screen review-screen">

      {/* Header */}
      <div className="review-header">
        <button className="review-back-btn" onClick={onBack} aria-label="Back to questionnaire">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="19" y1="12" x2="5" y2="12"/>
            <polyline points="12 19 5 12 12 5"/>
          </svg>
        </button>
        <div className="review-header-text">
          <h2 className="review-title">Review Answers</h2>
          <p className="review-subtitle">
            {hasAnswers
              ? `${collectedAnswers.length} answer${collectedAnswers.length !== 1 ? "s" : ""} recorded`
              : "No answers recorded yet"}
          </p>
        </div>
      </div>

      {/* Answer list */}
      <div className="review-list">
        {!hasAnswers ? (
          <div className="review-empty">
            <div className="review-empty-icon">
              <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="8" y="6" width="32" height="36" rx="4" stroke="currentColor" strokeWidth="2"/>
                <line x1="16" y1="18" x2="32" y2="18" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                <line x1="16" y1="26" x2="28" y2="26" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              </svg>
            </div>
            <p className="review-empty-text">
              Your answers will appear here as you complete each question.
            </p>
          </div>
        ) : (
          collectedAnswers.map((item, index) => (
            <div key={item.questionId || index} className="review-item">
              <div className="review-item-header">
                <span className="review-item-num">Q{index + 1}</span>
                {/* Edit button scaffold — wired up for future re-record flow */}
                <button
                  className="review-edit-btn"
                  onClick={() => onEditAnswer && onEditAnswer(item, index)}
                  aria-label={`Edit answer to question ${index + 1}`}
                >
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
                    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
                  </svg>
                  <span>Edit</span>
                </button>
              </div>
              <p className="review-item-question">{item.question}</p>
              <div className="review-item-answer">
                <p>{item.answer}</p>
              </div>
            </div>
          ))
        )}
      </div>

      {/* Footer note for future capability */}
      {hasAnswers && (
        <p className="review-footer-note">
          Tap Edit on any answer to re-record it.
        </p>
      )}

    </div>
  );
}
